import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormProps } from "../../../interfaces/form-action-interfaces";
import { Card, CardBody, CardFooter, CardHeader } from "../../forms/components/card";
import { FileUploadV2 } from "../../forms/components/file-upload-v2";
import { Input, SelectWithText } from "../../forms/components/input";
import { useRoleStore } from "../../roles/states/role.state";
import { useUserFormStore } from "../states/user.state";

const UserFormScreen = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { formParam, setFormParam, forms, setForms, generateForms, onSubmitForm, submitDone, reset, setFormSelectData } = useUserFormStore();
  const { getRoles, rolesSelectData } = useRoleStore();

  useEffect(() => {
    if (location) {
      setFormParam(location.state as FormProps);
      generateForms(location.state as FormProps);
      getRoles({ page: 0, limit: 100 });
    }
  }, [location]);

  useEffect(() => {
    if (rolesSelectData.length > 0) {
      setFormSelectData(5, rolesSelectData);
    }
  }, [rolesSelectData])

  useEffect(() => {
    console.log(submitDone);
    if (submitDone) {
      reset();
      navigate(-1)
    }
  }, [submitDone])

  return (
    <form onSubmit={e => {
      e.preventDefault();
      onSubmitForm();
    }}>
      <Card>
        <CardHeader title={`${formParam?.action} ${formParam?.title}`}/>  
        <CardBody>
          {
            forms?.map((v, k) => {
              switch (v?.type) {
                case 'file-upload-v2':
                  return <FileUploadV2
                    key={k}
                    title={v.title}
                    multiple={false}
                    description={'Upload File'}
                    name={v.name}
                    onUploadDone={(e) => {
                      setForms(k, e.data?.id);
                    }}
                    value={v.value}
                    disabled={v.disabled}
                    />;  
                case 'email':
                  return <Input
                    key={k}
                    title={v.title}
                    type={v.type}
                    placeholder={v.placeholder}
                    name={v.name}
                    value={v.value}
                    disabled={v.disabled}
                    onChange={(e) => {
                      setForms(k, e.target.value);
                    }}
                  />
                case 'password':
                  return <Input
                    key={k}
                    title={v.title}
                    type={v.type}
                    placeholder={v.placeholder}
                    name={v.name}
                    value={v.value}
                    disabled={v.disabled}
                    onChange={(e) => {
                      setForms(k, e.target.value);
                    }}
                  />
                case 'text':
                  return <Input
                    key={k}
                    title={v.title}
                    type={v.type}
                    placeholder={v.placeholder}
                    name={v.name}
                    value={v.value}
                    disabled={v.disabled}
                    onChange={(e) => {
                      setForms(k, e.target.value);
                    }}
                  />
                case 'select-with-text':
                  return <SelectWithText 
                    key={k}
                    title={v.title}
                    name={v.name}
                    selectData={v.selectData}
                    type={v.type}
                    value={v.value}
                    disabled={v.disabled}
                    onChangeSelectWithText={e => {
                      setForms(k, e);
                    }}
                    onInputChange={v.onInputChange}
                  />
                default:
                  return <div key={k}></div>
              }
            })
          }
        </CardBody>
        <CardFooter>
          <button 
            type="submit" 
            className="btn btn-success btn-lg"
            onClick={(e) => {
              e.preventDefault();
              onSubmitForm();
            }}>
              Submit
          </button>
        </CardFooter>
      </Card>  
    </form>
  );
}

export default UserFormScreen;